"use client";

import { useLocale } from "next-intl";
import { useProjectConfigs } from "@/features/project/ProjectContext";
import { cn } from "@/lib/cn";

/**
 * The tenant's announcement banner at the top of the sidebar.
 *
 * Authored per language, so it renders only when there's text for the *current*
 * locale — a banner in the wrong language is worse than none. The link is
 * optional: without one it's plain text rather than a dead anchor.
 */
export function Headline() {
  const locale = useLocale();
  const { headline, headlineLink } = useProjectConfigs();

  const text = headline?.[locale];
  if (!text) return null;

  const className = cn(
    "block bg-primary-opacity-25 px-5 py-4 text-base",
    headlineLink && "hover:underline"
  );

  return headlineLink ? (
    <a
      href={headlineLink}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {text}
    </a>
  ) : (
    <p className={className}>{text}</p>
  );
}
